const CHECKOUT_AUTH_TOKEN_KEY = "checkout_auth_token";

/**
 * Stores a short-lived checkout JWT for the pending-payment registration flow.
 * Used as Authorization Bearer when the browser keeps a previous session cookie.
 * @param {string | null | undefined} token
 */
export function persistCheckoutAuthToken(token) {
  if (typeof token !== "string" || !token.trim()) {
    clearCheckoutAuthToken();
    return;
  }
  try {
    sessionStorage.setItem(CHECKOUT_AUTH_TOKEN_KEY, token.trim());
  } catch {
    /* ignore storage access errors */
  }
}

/**
 * @returns {string | null}
 */
export function getCheckoutAuthToken() {
  try {
    const token = sessionStorage.getItem(CHECKOUT_AUTH_TOKEN_KEY);
    return typeof token === "string" && token.trim() ? token.trim() : null;
  } catch {
    return null;
  }
}

export function clearCheckoutAuthToken() {
  try {
    sessionStorage.removeItem(CHECKOUT_AUTH_TOKEN_KEY);
  } catch {
    /* ignore storage access errors */
  }
}

/**
 * Builds fetch headers for checkout-owned requests (order status / create-intent).
 * @param {Record<string, string>} [baseHeaders]
 * @returns {Record<string, string>}
 */
export function buildCheckoutAuthHeaders(baseHeaders = {}) {
  const headers = { ...baseHeaders };
  const token = getCheckoutAuthToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

export const CHECKOUT_AUTH_TOKEN_SESSION_KEY = CHECKOUT_AUTH_TOKEN_KEY;
